import React, { useEffect, useLayoutEffect, useState } from "react";
import "photoswipe/dist/photoswipe.css";
// import { Gallery, Item } from "react-photoswipe-gallery";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getPropertyDetail } from "reduxStore/action/propertyActions";
import strings from "translate/language";
import { handleDetailResponse, handleListResponse, seo } from "utils/utils";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";
import {
  getConfiguration,
  getMasterList,
} from "reduxStore/action/masterActions";
import { MasterTypeHelper } from "utils/constants";

const ViewPropertyNextPage = () => {
  const navigate = useNavigate();

  const params = useParams();
  const { property_id = "" } = params || {};

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();
  const [viewDetails, setViewDetails] = useState({});
  const [getbusinessDM, setGetBusinessDM] = useState({});
  const [getmarketingAI, setGetMarketingAI] = useState({});
  const [getMarketingBD, setGetMarketingBD] = useState({});
  const [unitTypeData, setUnitTypeData] = useState([]);
  const [typologyData, setTypologyData] = useState([]);
  const getPropertyDetailSelector =
    useSelector((state) => state.propertyData) || [];

  const unitTypeSelector = useSelector((state) => state.masterData) || {};
  const configurationsSelector =
    useSelector((state) => state.configurations) || {};
  const handleStringObj = (data) => {
    let obj = {};
    if (data && data !== "[object Object]") {
      let typeofAdr = typeof data;
      if (typeofAdr === "string" || typeofAdr === "object") {
        obj = typeofAdr === "object" ? data : JSON.parse(data);
      }
    }
    return obj;
  };
  useEffect(() => {
    if (getPropertyDetailSelector.response) {
      const { response } = getPropertyDetailSelector;
      if (response?.status === 200) {
        setViewDetails(handleDetailResponse(response?.data));
      } else {
        setViewDetails({});
      }
      if (viewDetails?.business_development_marketing) {
        setGetBusinessDM(
          handleDetailResponse(
            handleStringObj(viewDetails?.business_development_marketing)
          )
        );
      }
      if (viewDetails?.marketing_assistance_information) {
        setGetMarketingAI(
          handleDetailResponse(
            handleStringObj(viewDetails?.marketing_assistance_information)
          )
        );
      }
      if (viewDetails?.marketing_business_development) {
        setGetMarketingBD(
          handleDetailResponse(
            handleStringObj(viewDetails?.marketing_business_development)
          )
        );
      }
    }
  }, [getPropertyDetailSelector]);

  useEffect(() => {
    if (unitTypeSelector.response) {
      const { response } = unitTypeSelector;
      if (response?.status === 200) {
        setUnitTypeData(handleListResponse(response.data));
      } else {
        setUnitTypeData([]);
      }
    }
  }, [unitTypeSelector]);

  useEffect(() => {
    if (configurationsSelector.response) {
      const { response } = configurationsSelector;
      if (response?.status === 200) {
        setTypologyData(handleListResponse(response.data));
      } else {
        setTypologyData([]);
      }
    }
  }, [configurationsSelector]);

  useLayoutEffect(() => {
    dispatch(getPropertyDetail({ property_id: property_id }));
    dispatch(getConfiguration());
    dispatch(getMasterList({ type: MasterTypeHelper.unitType }));
  }, []);
  useEffect(() => {
    seo({
      title: "Property Details",
      metaDescription: "View property details",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.propertyDetails}
        url={"/property"}
        parentListing={strings.propertyListing}
        titleactive={strings.viewPropertyDetails}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.propertyDetails}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.reraPossession} :{" "}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.rera_possession ? moment(getbusinessDM?.rera_possession).format(
                          "DD-MM-yyyy hh:mm a"
                        ) : strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.expectedPossession} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.expected_possession ? moment(getbusinessDM?.expected_possession).format(
                          "DD-MM-yyyy hh:mm a"
                        ) : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.landparcel} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.land_parcel?.units ||
                          strings.notavailable}{" "}
                        {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.land_parcel?.unitType
                            )
                          )?.title
                        }
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.towers} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.towers || strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.typology} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {handleDetailResponse(
                          typologyData.filter(
                            (i) => i._id === getbusinessDM?.typology
                          )
                        )?.title || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.reraCarpet} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.rera_carpet?.units ||
                          strings.notavailable}{" "}
                        {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.rera_carpet?.unitType
                            )
                          )?.title
                        }
                      </label>
                    </div>
                    {/* google digital marketing */}
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.google} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.digital_marketing
                          ?.digital_marketing_google
                          ? "yes"
                          : "no" || strings.notavailable}{" "}
                        {/* {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.rera_carpet?.unitType
                            )
                          )?.title
                        } */}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.builtUpArea} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.builtup_area?.units ||
                          strings.notavailable}{" "}
                        {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.builtup_area?.unitType
                            )
                          )?.title
                        }
                      </label>
                    </div>
                    {/*  facebook digital marketing*/}
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.facebook} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.digital_marketing
                          ?.digital_marketing_facebook
                          ? "yes"
                          : "no" || strings.notavailable}{" "}
                        {/* {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.rera_carpet?.unitType
                            )
                          )?.title
                        } */}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.salabelArea} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.saleble_area?.units ||
                          strings.notavailable}{" "}
                        {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.saleble_area?.unitType
                            )
                          )?.title
                        }
                      </label>
                    </div>
                    {/* instagram digital marketing */}
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.instagram} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.digital_marketing
                          ?.digital_marketing_instagram
                          ? "yes"
                          : "no" || strings.notavailable}{" "}
                        {/* {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.rera_carpet?.unitType
                            )
                          )?.title
                        } */}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.allInclusive} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.all_inclusive || strings.notavailable}
                      </label>
                    </div>
                    {/* taboola digital marketing */}
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.taboola} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.digital_marketing
                          ?.digital_marketing_taboola
                          ? "yes"
                          : "no" || strings.notavailable}{" "}
                        {/* {
                          handleDetailResponse(
                            unitTypeData.filter(
                              (i) =>
                                i._id === getbusinessDM?.rera_carpet?.unitType
                            )
                          )?.title
                        } */}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.paymentScheme} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.payment_scheme || strings.notavailable}
                      </label>
                    </div>
                    {/* taboola digital marketing */}
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.timesquare} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.digital_marketing
                          ?.digital_marketing_timeSquare
                          ? "yes"
                          : "no" || strings.notavailable}{" "}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.tentativeClosingPrice} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.tentative_closing_price ||
                          strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.currentStage} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.current_stage || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.Positive} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.positive || strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-ce">
                      <label htlmFor="exampleInputMobileNo">
                        {strings.Negative} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.negative || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.supportsForCP} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.supports_for_cp || strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.upcomingInfrastructure} :
                      </label>
                    </div>

                    <div className="col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getbusinessDM?.upcoming_infrastructure ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.hoardings} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.startDate} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.endDate} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.hoardings?.text ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.hoardings?.start_date ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.hoardings?.end_date ||
                          strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.newspaper} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.startDate} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.endDate} :
                      </label>
                    </div>

                    <div className="col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.newspaper?.text ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.newspaper?.start_date ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.newspaper?.end_date ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.whatsappSMS} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.startDate} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.endDate} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.whatsapp_sms?.number ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.whatsapp_sms?.start_date ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.whatsapp_sms?.end_date ||
                          strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.blastRadioJingles} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.startDate} :
                      </label>
                      <br />
                      <label htmlFor="exampleInputMobileNo">
                        {strings.endDate} :
                      </label>
                    </div>

                    <div className="col-md-3 align-items-center">
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.blast_radio_jingles?.text ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.blast_radio_jingles?.start_date ||
                          strings.notavailable}
                      </label>
                      <br />
                      <label
                        htlmFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getmarketingAI?.blast_radio_jingles?.end_date ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.residentLocation} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.resident_location ||
                          strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.officeLocation} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.office_location ? getMarketingBD?.office_location : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.occupation} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.occupation || strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.customerDesignation} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.customer_designation ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.AnnualIncome} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.annual_income || strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.ethnicity} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.ethnicity || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.ageGroup} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.age_group || strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.RentedOwned} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.rented_owned || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.CurrentStayConfiguration} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.current_stay_configuration ||
                          strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.CustomerBudget} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.customer_budget ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.PreferredTypology} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.preferred_typology ||
                          strings.notavailable}
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.PurposeofPurchase} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.purpose_of_purchase ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.possessionexpected} :
                      </label>
                    </div>
                    <div className=" col-md-3 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getMarketingBD?.possessionexpected ? moment(getMarketingBD?.possessionexpected).format(
                          "DD-MM-yyyy"
                        ) : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  {/* <Button
                    className="btn btn-color"
                    onClick={() => {
                      navigatpage("/viewproperty/" + property_id);
                    }}
                    label={strings.back}
                  ></Button> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewPropertyNextPage;
